import {
  Box,
  CircularProgress,
  ClickAwayListener,
  colors,
  Divider,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import { selectActiveSession } from "app/modules/schools/selectors";
import {
  getStudentByName,
  getStudentByNameAndSession,
} from "app/services/schoolService/studentReport.service";
import { FormatFullName, formatGuardianString } from "app/utils/helper";
export const StudentCard = ({
  item,
  showReg = true,
  showAdmNo = true,
  showDivider = true,
}) => {
  return (
    
    <Box
      my={1}
      sx={{
        color: item?.active
          ? "primary"
          : item?.migrated
          ? colors.blue[500]
          : item?.suspended
          ? colors.yellow[900]
          : item?.promoted
          ? colors.green[700]
          : item?.deleted && colors.red[600],
        cursor: "pointer",
      }}
    >
      <Stack direction="row" spacing={1} alignItems={"center"} px={2}>
        {/* student profile pic */}
        <div>
          <img
            src={
              item?.profilePic ? item?.profilePic : "/image-placeholder.jpeg"
            }
            alt="student"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        {/* student details */}
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "15px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {item?.name ??
              FormatFullName(item?.firstName, item?.middleName, item?.lastName)}
          </Typography>

          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            
              {formatGuardianString(item?.gender, item?.fatherName || item?.motherName || "")}  
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            Class Info:- {item?.classInfo ?? item?.className ?? ""}
          </Typography>
          <Stack direction={"row"} gap={2} alignItems={"center"}>
            {showReg && (
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "12px",
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                }}
              >
                Reg No:- {item?.registrationNumber}
              </Typography>
            )}
            {showAdmNo && (
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "12px",
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                }}
              >
                Adm No:- {item?.admissionNumber}
              </Typography>
            )}
          </Stack>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            Status:-{" "}
            {item?.deleted ? (
              <span>Deleted</span>
            ) : item?.migrated ? (
              <span>Migrated</span>
            ) : item?.active ? (
              <span>Active</span>
            ) : item?.promoted ? (
              <span>Promoted</span>
            ) : item?.suspended ? (
              <span>Suspended</span>
            ) : (
              ""
            )}
          </Typography>
        </Stack>
      </Stack>
      {showDivider && <Divider sx={{ background: "rgba(0,0,0,0.3)", mt: 1 }} />}
    </Box>
  );
};
const StudentSearchDialogForSiblings = ({
  value,
  radio,
  handleOnClickStudent,
}) => {
  const [state, setState] = useState({
    name: "",
    page: 1,
    studentData: {},
    menuOpen: false,
    selectedStudent: [],
    isFocus: false,
  });
  const listRef = useRef(null);
  const selectedSession = useSelector(selectActiveSession);
  const {
    isFetching: getStudentByNameFetching,
    isLoading: getStudentByNameLoading,
  } = useQuery({
    queryKey: ["getStudentByName", state.name, state.page, radio],

    queryFn: () => {
      const params = {
        ...(radio === "activeSession" && {
          session: selectedSession,
          active: true,
        }),

        studentName: undefined,
        page: state.page,
      };

      switch (value) {
        case "Student Name":
          params.studentName = state.name;
          break;
        default:
          break;
      }
      if (radio === "activeSession") {
        return getStudentByNameAndSession(params);
      } else {
        return getStudentByName(params);
      }
    },
    onSuccess: (success) => {
      if (Number(state.page) !== 1) {
        setState((prev) => ({
          ...prev,
          studentData: {
            ...prev.studentData,
            ...success?.data,
            list: [...prev?.studentData?.list, ...success?.data?.list],
          },
        }));
      } else {
        setState((prev) => ({ ...prev, studentData: success?.data }));
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    },
    enabled: state.name ? true : false,
  });
  const handleLinkClick = (e, studentDocId) => {
    if (handleOnClickStudent) {
      e.preventDefault();
      handleOnClickStudent(studentDocId);
      setState((prev) => ({ ...prev, isFocus: false }));
      return;
    }
  };
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      name: "",
      page: 1,
      studentData: {},
      menuOpen: false,
      selectedStudent: [],
    }));
  }, [value]);
  useEffect(() => {
    if (listRef.current) {
      const scrollDiv = listRef.current;
      setState((prev) => ({
        ...prev,
        scrollPosition: scrollDiv.scrollTop,
      }));
    }
  }, [state.page]);

  useEffect(() => {
    if (listRef.current && Number(state.page) > 1) {
      const scrollDiv = listRef.current;
      scrollDiv.scrollTo({
        top: state.scrollPosition || 0,
      });
    }
  }, [state.studentData]);

  return (
    <Box>
      <ClickAwayListener
        onClickAway={() => setState((prev) => ({ ...prev, isFocus: false }))}
      >
        <Wrapper>
          <div className="input_box">
            <input
              onFocus={() => setState((prev) => ({ ...prev, isFocus: true }))}
              type={"text"}
              placeholder={`Type ${value}`}
              value={state.name}
              onChange={(e) => {
                e.stopPropagation();
                setState((prev) => ({
                  ...prev,
                  name: e.target.value,
                  ...(state.page !== 1 && { page: 1 }),
                  ...(!e.target.value && { studentData: {} }),
                }));
              }}
              className="custom_input"
            />
            {state.name && (
              <div
                onClick={() =>
                  setState((prev) => ({ ...prev, name: "", studentData: {} }))
                }
              >
                <Close className="close_icon" />
              </div>
            )}
          </div>
          {/* box */}
          {state.name && state.isFocus && (
            <div className="student_box__wrapper">
              <div className="student_box" ref={listRef} id="scrollDivStudent">
                {(getStudentByNameFetching || getStudentByNameLoading) && (
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    sx={{ position: "absolute", left: 0, right: 0 }}
                  >
                    <CircularProgress />
                  </Stack>
                )}

                {state.studentData?.list?.map((item, ind) => (
                  <Stack
                    key={ind}
                    sx={{
                      ":hover": {
                        backgroundColor: "rgba(0,0,0,0.05)",
                      },
                    }}
                    onClick={(e) => handleLinkClick(e, item)}
                  >
                    <StudentCard item={item} key={ind} />
                  </Stack>
                ))}
                {state.studentData?.pages !== state.studentData?.page && (
                  <Stack direction={"row"} justifyContent={"center"}>
                    <Typography
                      sx={{
                        color: "blue",
                        textDecoration: "underline",
                        cursor: "pointer",
                        textAlign: "center",
                        display: "inline-block",
                        mb: 1,
                      }}
                      onClick={() =>
                        setState((prev) => ({ ...prev, page: prev.page + 1 }))
                      }
                    >
                      more
                    </Typography>
                  </Stack>
                )}
              </div>
            </div>
          )}
        </Wrapper>
      </ClickAwayListener>
    </Box>
  );
};

const Wrapper = styled(Box)`
  position: relative;
  transition: all 0.5s;
  .input_box {
    padding: 3px;
    border: 0.6px solid rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 300px;
    background-color: #fff;
    border-radius: 5px;
    :hover {
      border-color: var(--primary);
    }
    :focus-within {
      border: 2px solid var(--primary);
    }
  }
  .close_icon {
    font-size: 10px;
    opacity: 0.6;
    background-color: #f1f1;
    cursor: pointer;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .custom_input {
    width: 100%;
    outline: none;
    border: none;
    font-size: 14px;
    height: 30px;
  }

  .student_box__wrapper {
    position: absolute;
    width: 400px;
    height: 370px;
    padding-top: 4px;
    z-index: 300;
    .student_box {
      height: 100%;
      width: 100%;
      background-color: #fff;
      border-radius: 15px;
      box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
      overflow-y: auto;
    }
  }
`;

export default StudentSearchDialogForSiblings;
